export default __webpack_public_path__ + "static/tooltip-contents-do-light-decd616de3b680bccc7c3f87f9792b8d.png";